import React from "react";

import styled from "@emotion/styled";
import { css } from "@emotion/react";

import CenterModal from "@ats/src/components/modals/CenterModal";
import Button from "@ats/src/components/shared/Button";
import { trackEvent } from "@shared/lib/posthog";

type Props = {
  onCancel: () => void;
  currentPlanName: string;
  jobLimit: number;
  nextPlanName?: string;
  location: any;
  history: any;
};

function UpgradePlanModal(props: Props) {
  const { currentPlanName, jobLimit, nextPlanName } = props;
  // window.logger("%c[UpgradePlanModal] RENDER ", "color: #207c3f", {
  //   currentPlanName,
  //   jobLimit,
  //   nextPlanName,
  // });

  const handleViewPlans = () => {
    trackEvent("upgrade_plan_view_plans_clicked", { current_plan: currentPlanName, trigger: "job_limit" });
    props.history.push({
      pathname: "/hire/settings/billing",
      state: {
        orginalPathname: props.location.pathname,
      },
    });
    props.onCancel();
  };

  return (
    <CenterModal headerTitleText={"Upgrade your plan"} onCancel={props.onCancel}>
      <>
        <Styled.Instructions>
          {`You have reached your limit of ${jobLimit} published job${
            jobLimit === 1 ? "" : "s"
          } on the ${currentPlanName} plan.`}
        </Styled.Instructions>
        <Styled.SecondaryMessage>
          {nextPlanName ? (
            <>
              To publish more jobs, please upgrade to the <b>{nextPlanName}</b> plan or archive an
              existing job.
            </>
          ) : (
            `To publish more jobs, please upgrade your plan or archive an existing job.`
          )}
        </Styled.SecondaryMessage>
        <Styled.ButtonContainer>
          <Button name="viewPlansButton" type="submit" onClick={handleViewPlans}>
            View plans
          </Button>
          <Button styleType="secondary" onClick={props.onCancel}>
            Cancel
          </Button>
        </Styled.ButtonContainer>
      </>
    </CenterModal>
  );
}

export default UpgradePlanModal;

/* Styled Components
======================================================= */
let Styled: any;
Styled = {};

Styled.Instructions = styled.p((props) => {
  const t: any = props.theme;
  return css`
    label: UpgradePlanModal_Instructions;
    ${[t.mb(3)]}

    a {
      ${t.text.medium}
    }

    a:hover {
      text-decoration: underline;
    }
  `;
});

Styled.SecondaryMessage = styled.p((props) => {
  const t: any = props.theme;
  return css`
    label: UpgradePlanModal_SecondaryMessage;
    ${[t.mb(5), t.text.sm]}
    color: ${t.dark ? t.color.gray[400] : t.color.gray[600]};
  `;
});

Styled.ButtonContainer = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: UpgradePlanModal_ButtonContainer;
    display: flex;
    > * {
      ${t.mr(3)}

      &:last-of-type {
        ${t.mr(0)}
      }
    }
  `;
});
